import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { UtilService, DialogService, TranslationService } from '../../index'; //app/shared/index barrel;
import { DialogModal } from '../../dialog/dialog-modal.model';
import { DialogResult } from '../../dialog/dialog-result.model';

@Component({
  selector: 'wl-confirm-safeguard',
  templateUrl: 'confirm-safeguard-dialog.component.html',
    standalone: false
})
export class ConfirmSafeguardDialogComponent implements OnInit {
  public _translationService: TranslationService;
  public _utilService: UtilService;

  @Input() public titleText: string = '';
  @Input() public headerText: string = '';
  @Input() public messageText: string = '';
  @Input() public yesText: string = '';
  @Input() public noText: string = '';

  @Output() onDialogResult = new EventEmitter<DialogResult>();

  public dialogResult: DialogResult;
  public selectedYes: boolean;
  public selectedNo: boolean;
  public showModal = false;

  public constructor(translationService: TranslationService, utilService: UtilService) {
    this._translationService = translationService;
    this._utilService = utilService;

    this.dialogResult = DialogResult.NotSet;
    this.selectedYes = false;
    this.selectedNo = true;
  }

  public ngOnInit() {}
  public showDialog = (): void => {
    if (this._utilService.isNullEmptyOrWhitespace(this.titleText)) {
      this.titleText = this._translationService.getInstant('common.confirmation');
    }
    if (this._utilService.isNullEmptyOrWhitespace(this.yesText)) {
      this.yesText = this._translationService.getInstant('common.yes');
    }
    if (this._utilService.isNullEmptyOrWhitespace(this.noText)) {
      this.noText = this._translationService.getInstant('common.no');
    }
    if (this._utilService.isNullEmptyOrWhitespace(this.messageText)) {
      this.noText = this._translationService.getInstant('common.no');
    }

    this.showModal = true;
  };
  public closeDialog = (): void => {
    this.showModal = false;
  };

  public dialogYes = (): void => {
    this.dialogResult = DialogResult.Yes;
    this.onDialogResult.emit(this.dialogResult);
    this.showModal = false;
  };
  public dialogNo = (): void => {
    this.dialogResult = DialogResult.No;
    this.onDialogResult.emit(this.dialogResult);
    this.showModal = false;
  };

  public yesChanged = ($event: any): void => {
    if (this.selectedYes == true) {
      this.selectedNo = false;
    } else {
      this.selectedNo = true;
    }
  };

  public noChanged = ($event: any): void => {
    if (this.selectedNo == true) {
      this.selectedYes = false;
    } else {
      this.selectedYes = true;
    }
  };
}
